import React, { useEffect, useRef } from "react";
import { CalenderIcon } from "utils/icon";

interface InputFieldProps {
  type?: string;
  error?: any;
  labelFont?: any;
  isError?: boolean;
  value?: string | number;
  name?: string;
  label?: string;
  placeholder?: string;
  noLabel?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: any;
  disabled?: boolean;
  height?: string;
  fontSize?: string;
  borderBottomRadius?: string;
  borderTopRadius?: string;
  isDollar?: boolean;
  isPercentage?: boolean;
  maxLength?: number;
  onKeyDown?: any;
  onClick?: any;
  readOnly?: boolean;
  _className?: any;
  "data-testid"?: string;
  "aria-label"?: string;
  "aria-describedby"?: string;
}

const InputField = ({
  type = "",
  error = "",
  labelFont,
  isError = false,
  value = "",
  name = "name",
  label = "label",
  placeholder = "Placeholder",
  noLabel = false,
  onChange = () => {},
  onBlur = () => {},
  disabled = false,
  height = "",
  fontSize = "",
  borderBottomRadius = "",
  borderTopRadius = "",
  isDollar = false,
  isPercentage = false,
  maxLength = undefined,
  onKeyDown,
  onClick,
  readOnly = false,
  _className,
  ...inputProps
}: InputFieldProps) => {
  const quantityInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const ignoreScroll = (e: WheelEvent) => {
      e.preventDefault();
    };
    quantityInputRef.current?.addEventListener("wheel", ignoreScroll);
    return () => {
      quantityInputRef.current?.removeEventListener("wheel", ignoreScroll);
    };
  }, []);

  return (
    <div className="relative">
      <div className="absolute bottom-[-20px] text-xs text-red">{error}</div>
      {!noLabel && (
        <div
          style={{ fontSize: labelFont ? labelFont : "" }}
          className={`text-xs uppercase font-bold text-txtSecondary mb-[3px] leading-[15.62px]`}
        >
          {label}
        </div>
      )}
      <div className="relative" onClick={onClick}>
        <input
          style={{
            boxShadow: "none !important",
            WebkitAppearance: "none",
            height: height ? height : "",
            fontSize: fontSize ? fontSize : "",
            borderColor: error ? "#FFCCCC " : "",
            borderBottomLeftRadius:
              borderBottomRadius === "none" ? "0px" : "7px",
            borderBottomRightRadius:
              borderBottomRadius === "none" ? "0px" : "7px",
            borderTopLeftRadius: borderTopRadius === "none" ? "0px" : "7px",
            borderTopRightRadius: borderTopRadius === "none" ? "0px" : "7px",
          }}
          ref={quantityInputRef}
          onBlur={onBlur}
          type={type}
          autoComplete="off"
          className={`dcinput ${disabled ? "bg-bgThird" : "bg-white"} ${
            isDollar && value !== "" && "!px-[23px]"
          } ${isPercentage && value !== "" && "!px-[26px]"} ${
            isError
              ? "border-red"
              : "border-strokePrimary hover:!border-strokeActive focus:border-strokeActive"
          } focus-visible:none focus-visible:ring-none 
            placeholder-txtSecondary h-[40px] w-full rounded-[7px] pl-[10px] py-[10px] text-sm border-[1px] outline-none focus-within:!outline-none !shadow-none focus:!outline-none ${_className}`}
          placeholder={placeholder}
          name={name}
          onChange={onChange}
          value={value}
          disabled={disabled}
          maxLength={maxLength}
          onKeyDown={onKeyDown}
          // dc-calendar fields have no typed-input path — their value only
          // changes through CustomCalender — so typing must be rejected up
          // front instead of silently reverting on the next render.
          readOnly={readOnly || type === "dc-calendar"}
          {...inputProps}
        />
        {isDollar && value !== "" && (
          <div className="absolute left-[14px] top-[11px] text-sm leading-[18px]">
            $
          </div>
        )}
        {isPercentage && value !== "" && (
          <div className="absolute left-[14px] top-[11px] text-sm leading-[18px]">
            %
          </div>
        )}
        {type === "dc-calendar" && (
          <span
            className={`right-3
          absolute  bottom-[12px]`}
            aria-hidden="true"
          >
            <CalenderIcon />
          </span>
        )}
      </div>
    </div>
  );
};

export default InputField;
